import { useMemo } from 'react';

export const useResetStorage = (params: {
  resetKey: string;
  resetValue: string;
  storageKeysToReset: string[];
}) => {
  return useMemo(() => {
    const resetValue = localStorage.getItem(params.resetKey);
    if (resetValue !== params.resetValue) {
      // 리셋이 필요한 경우, 관련된 모든 storage 키를 삭제
      params.storageKeysToReset.forEach((key) => {
        localStorage.removeItem(key);
      });
      localStorage.setItem(params.resetKey, params.resetValue);
      return true;
    }
    return false;
  }, [params.resetKey, params.resetValue, params.storageKeysToReset]);
};
